import type { SubscriptionTier } from "@/lib/api";

/**
 * Starter and Pro subscribers can pick a palette color for their own avatar.
 * Other tiers keep the default theme-tinted avatar treatment.
 */
export function canCustomizeOwnAvatarColor(
  tier: SubscriptionTier | string | null | undefined,
): boolean {
  return tier === 'starter' || tier === 'pro'
}

/**
 * Trial-like tiers share the same in-product UX (sidebar widget, banner,
 * trial-expired upgrade modal) and the same backend expiry mechanism
 * (date in `trial_ends_at` + credit-exhaustion guard).
 *
 * Mirror this list with `isTrialLike` in
 * `apps/backend/src/billing/billing-config.service.ts`.
 *
 * Add a tier here when introducing a new "trial-shaped" plan so all the
 * tier-keyed gates (banner, sidebar, expiry modal) pick it up automatically.
 */
export function isTrialLike(
  tier: SubscriptionTier | string | null | undefined,
): boolean {
  return tier === "trial" || tier === "partner_trial" || tier === "vip_trial" || tier === "pro_trial";
}

/**
 * Returns true for the unmetered Fairgen-internal tier.
 * Used to hide checkout/upgrade UI and show credits as "Unlimited".
 */
export function isFairgenInternalTier(
  tier: SubscriptionTier | string | null | undefined,
): boolean {
  return tier === "fairgen_internal";
}
